import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { mapFieldMetaData } from "@/components/widgets/module";
import { validateRecord, } from "@/utils/validations/validationRules";
export var useValidation = function (layoutMeta, field_defs) {
    var t = useTranslation(["common"]).t;
    var _a = useState(new Map()), validations = _a[0], setValidations = _a[1];
    var _b = mapFieldMetaData((layoutMeta === null || layoutMeta === void 0 ? void 0 : layoutMeta.layout) || [], field_defs), filteredFieldsDefs = _b[0], fieldMetadataMap = _b[1];
    var validationRules = useMemo(function () {
        var rules = new Map();
        fieldMetadataMap.forEach(function (field, fieldName) {
            var _a, _b, _c;
            var controls = field.type === undefined || field.type === ""
                ? []
                : fieldName === "email1"
                    ? "email"
                    : field.type;
            var fieldRules = Array.isArray(controls)
                ? controls
                : [controls];
            if (field.required && !["boolean"].includes(field.type || "")) {
                fieldRules.push("mandatory");
            }
            var er = /^-?[0-9]+$/;
            if (field.len && er.test(field.len)) {
                fieldRules.push("max:".concat(field.len));
            }
            if (((_a = field.validation) === null || _a === void 0 ? void 0 : _a.type) === "isbefore") {
                fieldRules.push("isbefore:".concat(field.validation.compareto));
            }
            if (((_b = field.validation) === null || _b === void 0 ? void 0 : _b.type) === "function") {
                fieldRules.push("function");
            }
            if (((_c = field.validation) === null || _c === void 0 ? void 0 : _c.type) === "range") {
                fieldRules.push("between:".concat(field.validation.min, ":").concat(field.validation.max));
            }
            if (fieldRules.length > 0)
                rules.set(fieldName, fieldRules);
        });
        return rules;
    }, [fieldMetadataMap]);
    var validate = useCallback(function (record) {
        var result = validateRecord(record, fieldMetadataMap, validationRules, t);
        setValidations(result);
        return result;
    }, [fieldMetadataMap, validationRules, t]);
    var resetValidations = useCallback(function () {
        setValidations(new Map());
    }, []);
    return { validations: validations, validate: validate, filteredFieldsDefs: filteredFieldsDefs, resetValidations: resetValidations };
};
